import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Dialog, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { UserType, UserVerificationStatus } from 'src/type/user';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import * as Yup from 'yup';

const Schema = Yup.object().shape({
  reason: Yup.string(),
});

const defaultValues = {
  reason: '',
};

type Props = {
  user: UserType;
  open: boolean;
  onClose: VoidFunction;
  handleReload: VoidFunction;
};

export default function UserEditRejectDialog({ user, open, onClose, handleReload }: Props) {
  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      if (
        user.verifyStatus === UserVerificationStatus.VERIFIED ||
        user.verifyStatus === UserVerificationStatus.REJECTED
      ) {
        throw new Error('ไม่สามารถอัพเดทข้อมูลได้');
      }

      await axios.post(endpoints.users.reject(user.uid), {
        note: data.reason,
      });
      handleReload();
      beforeClose();
      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
    } catch (error) {
      toastError(error);
    }
  });

  const beforeClose = () => {
    reset(defaultValues);
    onClose();
  };

  return (
    <Dialog open={open} onClose={beforeClose} maxWidth="sm" fullWidth>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>ปฏิเสธการยืนยันตัวตน</DialogTitle>

        <DialogContent>
          <RHFTextField
            multiline
            rows={3}
            name="reason"
            placeholder="หมายเหตุ"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={beforeClose} disabled={isSubmitting}>
            ยกเลิก
          </Button>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
            ดำเนินการต่อ
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
